<template>
  <div class="container">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="indigo"
          icon="mdi-vuetify"
          inline
          class="px-5 py-3"
        >
          <template #after-heading>
            <div class="display-2 font-weight-light">
              {{ $t('allRegisteredDomains') }}
            </div>
          </template>
          <all-name-spaces-table />
        </base-material-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import AllNameSpacesTable from '../tables/AllNameSpacesTable'

  export default {
    components: {
      AllNameSpacesTable,
    },

  }
</script>
